export default __webpack_public_path__ + "static/3-atolye-ankara-logo-6b89f62b952860913d383164e625e710.png";